import { render, staticRenderFns } from "./CustomerMedia.vue?vue&type=template&id=385f64ed&scoped=true&"
import script from "./CustomerMedia.vue?vue&type=script&lang=babel&"
export * from "./CustomerMedia.vue?vue&type=script&lang=babel&"
import style0 from "./CustomerMedia.vue?vue&type=style&index=0&id=385f64ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385f64ed",
  null
  
)

export default component.exports